module.exports = "pegasus/assets/square-instagram.png";